import React from 'react';

import style from './AsideMenu.module.scss';

interface Props {
  items?: React.ReactNode[];
}

const NavigationGroup = ({ items }: Props) => {
  if (!items?.filter(i => i).length) return null;

  return <ul className={style.navigation__group}>{items}</ul>;
};

export default NavigationGroup;
